module.exports = __webpack_public_path__ + "media/images/admin/icons/heart-b65bcc72103bb8c063ec3e8e5b37c5e4.svg";